module.exports = __webpack_public_path__ + "static/kw51_img_8-734872ebb4c294e93c0e573ab9a920df.png";